var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat-white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.894,
    height: 12,
    viewBox: "0 0 13.894 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M8.967,2.43H.6a.6.6,0,0,0-.6.6v6a.6.6,0,0,0,.6.6h.431V12L3.213,9.634H8.967a.6.6,0,0,0,.6-.6v-6a.6.6,0,0,0-.6-.6ZM2.452,6.606a.574.574,0,1,1,.406-.168.574.574,0,0,1-.406.168Zm2.333,0a.574.574,0,1,1,.406-.168.574.574,0,0,1-.406.168Zm2.333,0a.574.574,0,1,1,.22-.044.574.574,0,0,1-.22.044Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M13.292,0H4.927a.6.6,0,0,0-.6.6v.747H8.967A1.685,1.685,0,0,1,10.65,3.034V7.2h.031l2.18,2.367V7.2h.431a.6.6,0,0,0,.6-.6V.6a.6.6,0,0,0-.6-.6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/chat-white.5fbcf285d7a52a5788661c4a40cf04ee.svg";
export { ForwardRef as ReactComponent };